import React from 'react';
import { Modal, Button, FormItem, Input } from 'elmo-elements';
import { Fieldset } from 'src/components/Fieldset';
import { useCreateEditSubLocationState } from './hooks/useCreateEditSubLocationState';
import type { TCreateEditSubLocationModalProps } from './types';

export const CreateEditSubLocation = (props: TCreateEditSubLocationModalProps) => {
    const { isEdit = false, isOffice = true } = props;
    const { formData, handleChange, errors, handleSubmit, handleCloseModal, isLoading } =
        useCreateEditSubLocationState(props);

    const actionButtons = (
        <>
            <Button
                type="primary"
                onClick={handleSubmit}
                isLoading={isLoading}
                isDisabled={isLoading}
            >
                {isEdit ? 'Save' : 'Add'}
            </Button>
        </>
    );

    return (
        <Modal
            type="medium"
            closeModal={handleCloseModal}
            id={`${isEdit ? 'edit' : 'add'}-sub-location`}
            title={`${isEdit ? 'Edit' : 'Add'} Sub Location`}
            hasCloseFooterButton
            primaryButton={actionButtons}
            isOpened
        >
            <Fieldset isDisabled={isLoading}>
                <form action="#" method="POST" onSubmit={handleSubmit}>
                    <FormItem
                        className="required"
                        label="Sub Location Name"
                        message={errors.name?.[0]}
                        status={errors.name?.length ? 'error' : undefined}
                    >
                        <Input
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            ariaLabel="Sub Location Name"
                        />
                    </FormItem>

                    {isOffice && (
                        <>
                            <FormItem
                                className="required"
                                label="Capacity"
                                message={errors.capacity?.[0]}
                                status={errors.capacity?.length ? 'error' : undefined}
                            >
                                <Input
                                    name="capacity"
                                    value={formData.capacity ?? ''}
                                    onChange={handleChange}
                                    ariaLabel="Capacity"
                                />
                            </FormItem>

                            <FormItem
                                className="required"
                                label="Flex Capacity"
                                message={errors.flex?.[0]}
                                status={errors.flex?.length ? 'error' : undefined}
                            >
                                <Input
                                    name="flex"
                                    value={formData.flex ?? ''}
                                    onChange={handleChange}
                                    ariaLabel="Flex Capacity"
                                />
                            </FormItem>
                        </>
                    )}
                </form>
            </Fieldset>
        </Modal>
    );
};
